import React from 'react';
import { Content, Header, Page } from '@backstage/core-components';
import { LinksCard } from './LinksCard';

export const LinksPage = () => (
  <Page themeId="tool">
    <Header
      title="Links"
      subtitle="Quick access to development and support tools"
    />
    <Content>
      <LinksCard />
    </Content>
  </Page>
);
